export default __webpack_public_path__ + "static/media/004-bathroom.271b681b.svg";